var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"MenuItemInline"},[_c('a',{staticClass:"MenuItemInline-Link",class:[
      { 'MenuItemInline-Link--current': _vm.active },
      ("MenuItemInline-Link--" + _vm.colorScheme) ],attrs:{"title":_vm.description},on:{"click":_vm.openRoute}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }